export default "__VITE_ASSET__e87a3d53__"